import { requestedEmbryoCycleFixture } from "@src/packages/cycles/test-fixtures/embryoReportFixture";
import type { Phase } from "@src/packages/cycles/hooks/useCycles";
import { usePastCycleDetail } from "@src/packages/cycles/hooks/usePastCycleDetail";

const NO_PHASES: Phase[] = [];

/**
 * The cycle behind an embryo report: its type and the phases that carry the
 * lab counts (eggs retrieved, mature, fertilized...) and how the eggs were
 * fertilized.
 */
export function useEmbryoTestingCycle(cycleId: string): {
  cycleType: string | null;
  phases: Phase[];
} {
  const { rawCycle, phases } = usePastCycleDetail(cycleId);
  const fixture = requestedEmbryoCycleFixture();
  if (fixture && fixture.cycle.id === cycleId) {
    return { cycleType: fixture.cycle.cycleType, phases: fixture.phases };
  }
  return {
    cycleType: rawCycle?.cycleType ?? null,
    phases: phases ?? NO_PHASES,
  };
}
